import { render } from "./IconChart.vue?vue&type=template&id=0a7a0f3f"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a7a0f3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a7a0f3f', __exports__)) {
    api.reload('0a7a0f3f', __exports__)
  }
  
  module.hot.accept("./IconChart.vue?vue&type=template&id=0a7a0f3f", () => {
    api.rerender('0a7a0f3f', render)
  })

}


export default __exports__